import {
  put,
  take,
  takeEvery,
  select
} from 'redux-saga/effects';
import ktRequest from '../utils/request';

export function * fetchEmployees () {
  const state = yield select();
  if (!state.identity.centerId) {
    yield take('FETCH_PROFILE_SUCCESS');
  }
  // dispatch a success action to the store with the logged in user
  yield put({
    type: 'FETCH_EMPLOYEES_LOADING'
  });

  const newState = yield select();

  const employeesResult = yield ktRequest.get('employees?centerId=' + newState.identity.centerId, 'identity');

  yield put({
    type: 'FETCH_EMPLOYEES_SUCCESS',
    employees: employeesResult.employees.map(e => { e.id = parseInt(e.id, 10); return e; })
  });
}

export const employeesSagas = [
  takeEvery('FETCH_EMPLOYEES', fetchEmployees)
];
